import type { FlagConfiguration } from '@atlassian/jira-flags';
import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	componentEditionFailedTitle: {
		id: 'project-components.flags.component-edition-failed-title',
		defaultMessage: "We couldn't edit the component",
		description:
			"Flag's title - appears when edited component couldn't be saved. For example: user is offline.",
	},
	componentEditionFailedDescription: {
		id: 'project-components.flags.component-edition-failed-description',
		defaultMessage: 'Something went wrong. Try again.',
		description:
			"Flag's description - appears when edited component couldn't be saved. For example: user is offline.",
	},
});

const UpdateError = (): FlagConfiguration => ({
	type: 'error',
	isAutoDismiss: false,
	title: messages.componentEditionFailedTitle,
	description: messages.componentEditionFailedDescription,
	messageId: 'project-directories.components.flags.update.flag.error',
	messageType: 'transactional',
});

export default UpdateError;
